import { RootState } from 'store/rootReducer';

export const ForbiddenErrorPageContentSelector = (state: RootState) => state.content.forbiddenErrorPage;
